import { memo } from 'react';
import { Info, Button, Box } from '@betty/moonlight';
import { GenericErrorScreenProps } from './GenericErrorScreen.types';

function GenericErrorScreen({
  locNS = 'common',
  title = 'genericErrorTitle',
  description = 'genericErrorDescription',
  locKey = 'reload',
  loading = false,
  ...props
}: GenericErrorScreenProps) {
  return (
    <Box centerContent flex={1} paddingHorizontal="space-600">
      <Info
        locNS={locNS}
        title={title}
        description={description}
        justifyContent="center"
        textAlign="center"
        paddingBottom="space-400"
      />
      {props.errorHandler ? (
        <Button
          variant="primary"
          locNS="common"
          locKey={locKey}
          loading={loading}
          onPress={props.errorHandler}
        />
      ) : (
        <Button
          variant="primary"
          locNS="common"
          locKey="reload"
          loading={loading}
          onPress={() => window.location.assign('/')}
        />
      )}
    </Box>
  );
}

export default memo(GenericErrorScreen);
